import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogActionsEnum, DialogComponent, DialogConfigInterface } from 'appShared/components/dialog';
import { PrizeGroupForm } from 'appEntries/panel/forms';
import { ApiError, ApiResponse, HttpStatusCodesEnum, PrizeGroupResponseInterface, PrizeGroupResponseModel, ServerResponseData, TradingPlanResponseModel, TradingPlanService } from '@spa/api';
import { TradingPlanFormErrorStatesEnum } from 'appEntries/panel/enums';
import { PanelPlansEditMessages } from 'appAssets/messages';
import { AlertTypesEnum } from 'appShared/enums';
import { AlertsService } from 'appShared/services';
import { FormInterface } from 'appShared/interfaces';
import { Subscription } from 'rxjs';
import { FormComponent } from 'appShared/widgets';
import { Router } from '@angular/router';

@Component({
  selector: 'app-prize-group-add',
  templateUrl: './prize-group-add.component.html',
  styleUrls: ['./prize-group-add.component.scss']
})
export class PrizeGroupAddComponent extends DialogComponent<PrizeGroupAddComponent> implements FormInterface, OnDestroy, OnInit {

  protected subscriptions: Subscription[];
  public form: PrizeGroupForm;
  public plan: TradingPlanResponseModel;
  public prizeGroups: PrizeGroupResponseModel[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      plan: TradingPlanResponseModel,
      config: DialogConfigInterface,
      prizeGroups: PrizeGroupResponseModel[],
    },
    protected router: Router,
    protected alertsService: AlertsService,
    protected tradingPlanService: TradingPlanService,

    public dialogRef: MatDialogRef<PrizeGroupAddComponent>,
  ) {
    super(dialogRef);
    this.subscriptions = [];
    this.config = data.config;
    this.prizeGroups = data.prizeGroups;
    this.plan = data.plan;
  }
  handleErrorResponse(response: ApiResponse<ApiError[] | PrizeGroupResponseInterface>, error: ApiError): string {
    if (Array.isArray(response.messages) && response.messages[0]) {
      return response.messages[0];
    }

    return this.getErrorMessageByApiError(error);
  }

  onFormSubmit(action?: number): void {
    if (action !== DialogActionsEnum.Confirm) {
      this.dialogRef.close(false);

      return;
    }

    if (this.validateForm()) {
      const requestSubscription = this.form.createRequest()
        .subscribe((response: ServerResponseData<PrizeGroupResponseInterface>) => {
          if (response.status !== HttpStatusCodesEnum.Ok) {
            (response.data as ApiError[]).map((error: ApiError) => this.handleErrorResponse(response, error))
              .filter((errorMessage: string) => {
                return errorMessage.trim();
              }).forEach((errorMessage: string) => {
                this.alertsService.addAlert(errorMessage);
              });

            return;
          }
          const data = response.data as PrizeGroupResponseInterface;
          this.alertsService.addAlert(this.getSuccessFormMessage(), AlertTypesEnum.Success);
          this.dialogRef.close(new PrizeGroupResponseModel(data));
        });
      this.subscriptions.push(requestSubscription);
    }
  }

  getFormMessages(controlLabel?: string, controlLength?: number): { [p: string]: string } {
    return {
      ...FormComponent.getFormMessages(controlLabel, controlLength),
      [PanelPlansEditMessages.OverlappedPrizeGroup.key]: PanelPlansEditMessages.OverlappedPrizeGroup.message,
      [PanelPlansEditMessages.TotalPercentageExceeded.key]: PanelPlansEditMessages.TotalPercentageExceeded.message,
      [PanelPlansEditMessages.PrizeGroupWinnerCountNotConfigured.key]: PanelPlansEditMessages.PrizeGroupWinnerCountNotConfigured.message,
    };
  }

  validateForm(): boolean {
    return this.form.validateForm(this.getFormMessages);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription && subscription.unsubscribe());
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = new PrizeGroupForm(this.tradingPlanService, this.plan, null);
    this.form.initForm();
  }

  getSuccessFormMessage(): string {
    return PanelPlansEditMessages.PrizeGroupCreationSucceed.message;
  }

  getErrorMessageByApiError(error: ApiError): string {
    if (error.status === TradingPlanFormErrorStatesEnum.CreatePlanFailed) {
      return PanelPlansEditMessages.PrizeGroupCreationFailed.message;
    }

    return PanelPlansEditMessages.UnknownError.message;
  }
}
